import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {UntypedFormGroup, UntypedFormControl} from '@angular/forms';

import * as _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent implements OnInit {

  @Input('pickerType') pickerType;

  @Input('label') label;

  @Input() set startInit(value: any) {
    if (value != undefined) {
      if(value != null){
        let start = value.split('-');
        this.range.controls.start = new UntypedFormControl(new Date(start[0], start[1] -1, start [2]));
      }else{
        this.range.controls.start = new UntypedFormControl();
      }
    }
  }

  @Input() set endInit(value: any) {
    if (value != undefined) {
      if(value != null){
        let end = value.split('-');
        this.range.controls.end = new UntypedFormControl(new Date(end[0], end[1] -1, end[2]));
      }else{
        this.range.controls.end = new UntypedFormControl();
      }
    }
  }

  @Input() set clearData(value: any){
    if(value == 'YES'){
      this.range.reset();
    }
  }

  startDate: any;
  endDate: any;

  @Input('disable') disable;
  
  @Output() valueChanged: EventEmitter<any> =   new EventEmitter();

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  constructor() { }

  ngOnInit() {
  }

  startDateValueChange(data){
    this.startDate = data;
  }

  valueChange(data){
    this.endDate = data;
    if(data !== null){
      const startOfMonth = moment(this.startDate).clone().startOf().format('YYYY-MM-DD');
      const endOfMonth   = moment(this.endDate).clone().endOf().format('YYYY-MM-DD');
      const date = [startOfMonth, endOfMonth];
      this.valueChanged.emit(date);
    }
  }
}
